<template>
  <div class="animated fadeIn">
    <h3>Irrigation Suitability Report</h3>
    <b-card v-for="(sample, index) in table_samples" no-body :key="index">
      <b-card-header>
        <span class="text-muted">
          Sample ID: {{ sample.id }}
        </span>
      </b-card-header>
      <b-card-body class="p-0">
        <b-table class="mb-0" :items="sample.results" :fields="columns" responsive bordered />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "SubmissionSarReport",
  props: {
    samples: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      columns: [
        { key: "lab_number", label: "Lab ID" },
        { key: "depth", label: "Depth" },
        { key: "horizon", label: "Horizon" },
        { key: "texture", label: "Texture" },
        { key: "sar", label: "SAR" },
        { key: "k", label: "K meq/L" },
        { key: "na", label: "Na meq/L" },
        { key: "ca_mg", label: "Ca+Mg meq/L" },
        { key: "mg", label: "Mg meq/L" },
        { key: "ca", label: "Ca meq/L" },
        { key: "ec", label: "EC dS/m" },
        { key: "ph", label: "pH" },
        { key: "saturation", label: "Saturation %" },
      ]
    }
  },
  computed: {
    table_samples() {
      return this.samples.map(sample => {
        return {
          ...sample,
          results: this.formSampleResult(sample.results)
        }
      })
    }
  },
  methods: {
    formSampleResult(results) {
      return results.map(result => {
        const { lab_number, depth, horizon, texture, sar, analytes } = result;
        
        return {
          lab_number, depth, horizon, texture, sar,
          ...analytes.reduce((acc, cur) => {
            return {
              ...acc,
              [cur.name === "Ca+Mg" ? "ca_mg" : cur.name.toLowerCase()]: cur.result
            }
          }, {})
        }
      })
    } 
  }
}
</script>